import { BaseFormComponent } from './BaseFormComponent';
import { IndexedDBTypes } from '@entities/dbType';
import { Component } from '@angular/core';

@Component({ template: '' })
export abstract class EntitySelectorFormComponent<
  TEntity extends IndexedDBTypes.IndexedDBType
> extends BaseFormComponent<TEntity> {}
